import PropTypes from 'prop-types';
import { Controller, useFormContext } from 'react-hook-form';
import Select from 'react-select';

import styles from './styles/styles.module.css';

function ElevatorSelector({ label, name, options, placeholder }) {
  const { control } = useFormContext();
  return (
    <div className={styles.selectWrapper}>
      <label htmlFor={name} className={styles.selectLabel}>
        {label}
      </label>
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <Select
            {...field} // Регистрируем поле для react-hook-form
            placeholder={placeholder}
            options={options}
            classNamePrefix="custom-select"
            className={`select ${styles.select_position}`}
            onChange={(selectedOption) => field.onChange(selectedOption.value)} // Передаем только значение
            value={
              options ? options.find((option) => option.value === field.value) : null // Устанавливаем выбранное значение
            }
            isSearchable={false}
            menuPlacement="auto"
            styles={{
              menu: (base) => ({
                ...base,
                position: 'absolute',
                top: '100%', // открываем меню под инпутом
                right: 0, // правый край меню совпадает с правым краем инпута
                width: '400px', // ширина меню
                minWidth: '200px',
                maxWidth: '600px',
                zIndex: 9999,
              }),
              menuList: (base) => ({
                ...base,
                maxHeight: '300px', // ограничение по высоте
              }),
            }}
          />
        )}
      />
    </div>
  );
}

export default ElevatorSelector;

ElevatorSelector.propTypes = {
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  options: PropTypes.arrayOf.isRequired,
  placeholder: PropTypes.string.isRequired,
};
